MP.m_intro_video_sizing = function(){
	var vid = document.getElementById( 'm_intro_video' );
	if ( ! vid ) return;
	var par = vid.parentNode;

	lib.on('resize',()=>{
		vid.style.height = par.offsetHeight + 'px';
	});
	vid.onloadeddata = function() {
		par.classList.add('is-loaded');
	};
};


// WEBPACK FOOTER //
// ./assets/js/m-intro.js